import { isTauri } from './platform.ts'
import { keychainClearToken, keychainGetToken, keychainSetToken } from './tauri.ts'

/**
 * Bearer token for API calls. Web: null (HttpOnly session cookie). Tauri: stored in the macOS Keychain
 * (ADR 0003) – tokens never go to localStorage in Tauri builds. The Keychain is read once per page load and kept in
 * memory: every read is a blocking call in the shell and can raise a Keychain prompt, so reading it per request
 * froze the app whenever macOS asked for access.
 */
let cached: Promise<string | null> | null = null

export async function getSessionToken(): Promise<string | null> {
  if (!isTauri) return null
  cached ??= keychainGetToken().catch((e) => {
    cached = null
    throw e
  })
  return cached
}

/** Stores a new/rotated token – the Keychain is only written when it actually changed. */
export async function setSessionToken(token: string): Promise<void> {
  if (!isTauri) return
  const current = await (cached ?? Promise.resolve(null)).catch(() => null)
  if (current === token) return
  cached = Promise.resolve(token)
  await keychainSetToken(token)
}

export async function clearSessionToken(): Promise<void> {
  if (!isTauri) return
  cached = Promise.resolve(null)
  await keychainClearToken()
}
